<template>
  <Select
    :modelValue="templateSourceInvoiceId"
    :options="templateSourceOptions"
    optionLabel="label"
    optionValue="value"
    class="w-full"
    @update:modelValue="$emit('update:templateSourceInvoiceId', $event)"
  >
    <template #option="slotProps">
      <div class="flex items-center gap-2">
        <i :class="getSourceTypeIconClass(slotProps.option.sourceType)" />
        <span v-html="slotProps.option.label"></span>
      </div>
    </template>
    <template #value>
      <div v-if="selectedTemplateSourceOption" class="flex items-center gap-2">
        <i :class="getSourceTypeIconClass(selectedTemplateSourceOption.sourceType)" />
        <span v-html="selectedTemplateSourceOption.label"></span>
      </div>
    </template>
  </Select>
</template>

<script setup lang="ts">
import Select from 'primevue/select';

import type { InvoiceItemSuggestionSource } from '@/views/operatingcostinvoices/components/operationcostinvoicelines/operatingCostInvoiceTypes';

interface TemplateSourceOption {
  label: string;
  value: string;
  sourceType: InvoiceItemSuggestionSource;
}

withDefaults(
  defineProps<{
    templateSourceInvoiceId?: string;
    templateSourceOptions: TemplateSourceOption[];
    selectedTemplateSourceOption?: TemplateSourceOption;
  }>(),
  {
    templateSourceInvoiceId: undefined,
    selectedTemplateSourceOption: undefined,
  },
);

defineEmits<{
  (e: 'update:templateSourceInvoiceId', value: string | undefined): void;
}>();

/** Get icon and color classes for template source type */
function getSourceTypeIconClass(sourceType: InvoiceItemSuggestionSource): string {
  switch (sourceType) {
    case 'ai':
      return 'pi pi-sparkles text-purple-500';
    case 'latest':
      return 'pi pi-receipt text-blue-500';
    case 'other':
      return 'pi pi-receipt text-gray-500';
    default:
      return 'pi pi-receipt';
  }
}
</script>
